export default "__VITE_ASSET__bc8JdXi3__"